/* ==========================================================================
   Elevate Floors — Seção 05: Featured projects

   O loop infinito, o arraste e a inércia vivem em ef-rail.js, compartilhados
   com a Seção 08. Aqui fica só o que é desta seção: o movimento contínuo, a
   largura dos cartões e o mute dos vídeos.
   ========================================================================== */
(function () {
  'use strict';

  function initRail(rail) {
    if (rail._efFeatBound || !window.EFRail) return;
    rail._efFeatBound = true;

    var SPEED = parseFloat(rail.dataset.speed);
    if (isNaN(SPEED)) SPEED = 34;

    /* O iPhone liga prefers-reduced-motion sozinho no Modo de Baixo Consumo,
       sem a pessoa ter escolhido isso em lugar nenhum — e aí o trilho aparecia
       parado em alguns aparelhos e andando em outros, sem explicação visível.
       Quem decide agora é o customizer: o padrão continua respeitando a
       preferência, e "Rodar sempre" a ignora. */
    if (rail.dataset.motion !== 'always' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches) SPEED = 0;

    var track = window.EFRail.attach(rail);

    /* largura dos cartões: sempre ~4 na tela, em qualquer monitor */
    function sizeCards() {
      var w = Math.max(210, Math.min(520, Math.round(window.innerWidth / 4.15)));
      rail.style.setProperty('--ef-card-w', w + 'px');
    }

    /* movimento contínuo, em px por SEGUNDO — não por frame, senão a
       velocidade mudaria conforme a taxa de atualização do monitor */
    var last = performance.now();
    function tick(now) {
      // teto de 48ms: sem ele, voltar de outra aba depois de um minuto daria
      // um dt gigante e o trilho saltaria milhares de pixels
      var dt = Math.min(48, now - last);
      last = now;
      if (SPEED > 0 && track.isIdle()) {
        rail.scrollLeft += (dt / 1000) * SPEED;
        track.loop();
      }
      requestAnimationFrame(tick);
    }

    /* vídeos sempre mudos: o atributo HTML não basta, alguns navegadores
       restauram o volume ao reidratar e aí o autoplay é recusado.

       O play NÃO acontece aqui: cada vídeo toca quando o card dele chega
       perto da tela e pausa quando sai (observador abaixo). Assim nada baixa
       enquanto o carrossel está lá embaixo na página, e as cópias do loop só
       carregam quando de fato passam pela tela. */
    function mute() {
      rail.querySelectorAll('video').forEach(function (v) {
        v.muted = true; v.defaultMuted = true; v.volume = 0;
      });
    }

    var vids = Array.prototype.slice.call(rail.querySelectorAll('video'));
    if ('IntersectionObserver' in window) {
      var vo = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (v.preload === 'none') v.preload = 'auto';
            v.muted = true;
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { rootMargin: '200px 300px' });
      vids.forEach(function (v) { vo.observe(v); });
    } else {
      vids.forEach(function (v) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); });
    }

    window.addEventListener('resize', sizeCards);
    sizeCards();
    requestAnimationFrame(function () { track.center(90); mute(); });

    // imagens lazy só definem tamanho ao carregar, então o scrollWidth do
    // primeiro frame pode estar errado; o observer se desliga sozinho
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        if (track.center(90)) mute();
        if (track.isCentered()) ro.disconnect();
      });
      ro.observe(rail);
    } else {
      setTimeout(function () { track.center(90); mute(); }, 400);
    }

    requestAnimationFrame(tick);
  }

  function init() {
    document.querySelectorAll('.ef-featured [data-rail]').forEach(initRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
